import { render, staticRenderFns } from "./couponsdetail.vue?vue&type=template&id=64ad6585&scoped=true"
import script from "./couponsdetail.vue?vue&type=script&lang=js"
export * from "./couponsdetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ad6585",
  null
  
)

export default component.exports